/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const NotFoundPage: any = lazyLoad(
  () => import('./index'),
  module => module.NotFoundPage,
);
